import AchievementBadge from "@/components/badges/AchievementBadge";
import ShareBadgeButton from "@/components/badges/ShareBadgeButton";
import { BADGE_CATEGORIES, COACH_BADGE_CATEGORIES } from "@/lib/badges";

function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" });
  } catch {
    return iso;
  }
}

export default function BadgeTimeline({ earned = [], categories = BADGE_CATEGORIES, userName, sharePath }) {
  if (!earned.length) {
    return <p className="text-sm text-slate-400 text-center py-6">Aucun badge pour l'instant — la première récompense arrive bientôt.</p>;
  }

  const sorted = [...earned].sort((a, b) => new Date(b.earned_at) - new Date(a.earned_at));

  return (
    <div className="space-y-4" data-testid="badge-timeline">
      {sorted.map((badge) => (
        <div key={badge.badge_code || badge.student_badge_id || badge.coach_badge_id} className="flex gap-4 items-start p-4 rounded-2xl border border-slate-100 bg-white">
          <AchievementBadge
            title={badge.title}
            icon={badge.icon}
            category={badge.category}
            categories={categories}
            earned
            size="sm"
            showLabel={false}
          />
          <div className="flex-1 min-w-0">
            <p className="font-semibold text-slate-900">{badge.title}</p>
            <p className="text-sm text-slate-500 mt-0.5">{badge.description}</p>
            <p className="text-xs text-slate-400 mt-2">Débloqué le {formatDate(badge.earned_at)}</p>
          </div>
          <ShareBadgeButton badge={badge} userName={userName} path={sharePath} />
        </div>
      ))}
    </div>
  );
}